import { type BuildDetailsFieldsParams, field, fullName, typedField } from '../fieldHelpers';
import type { DetailField } from '../types';

export function buildKeyContactsFields({ opportunity }: BuildDetailsFieldsParams): Array<DetailField> {
  const keyContacts = opportunity?.key_contacts;
  const contractAndCommercial = opportunity?.contract_and_commercial;

  return [
    typedField('Escalation Name', keyContacts?.escalation_nameescape__c, 'text'),
    typedField('Escalation Email', keyContacts?.escalation_email__c, 'email'),
    typedField('Escalation Phone', keyContacts?.escalation_phone__c, 'tel'),
    typedField(
      'Reservations Email',
      keyContacts?.booking_email__c,
      'email',
      'Email address used for Table/Calendar Booking to receive reservation confirmations.',
    ),
    typedField('Reservations Phone', keyContacts?.reservations_phone__c, 'tel'),
    typedField('Additional Reservation Email', contractAndCommercial?.additional_reservation_email__c, 'email'),
    typedField('Primary Contact Email', keyContacts?.primary_contact_email__c, 'email'),
    field(
      'Primary Contact',
      fullName(keyContacts?.primary_contact_first_name__c, keyContacts?.primary_contact_last_name__c),
    ),
    field(
      'System Manager Name',
      keyContacts?.system_manager_name__c,
      'Use this field to record the name of the system manager responsible for the integration.',
    ),
    typedField(
      'System Manager Email',
      keyContacts?.system_manager_email__c,
      'email',
      'Use this field to record the email of the system manager responsible for the integration.',
    ),
    typedField(
      'System Manager Phone',
      keyContacts?.system_manager_phone__c,
      'tel',
      'Use this field to record the phone number of the system manager responsible for the integration.',
    ),
  ];
}
